<div>
    <div class="ui menu margin-top-50 margin-bottom-30">
        <div class="item name-input">
            <div class="ui icon input">
                <input id="name" type="text" placeholder="Nom" [ngModel]="name" (ngModelChange)="onNameChanged($event)">
                <i class="search icon"></i>
            </div>
        </div>
        <div class="item" *ngIf="!deviceInfo.IsMobile()">
            <span class="sort">Tri</span>
            <button id="price-soring-button" class="ui primary button filter-input" (click)="sortingPriceClicked()">
                <i class="euro sign icon"></i>
                {{occasionsSorting.PriceSorting() == 0 ? "Aucun" :
                occasionsSorting.PriceSorting() == 1 ? "Croissant" : "Décroissant"}}
            </button>
            <button id="mileage-soring-button" class="ui primary button filter-input" (click)="sortingMileageClicked()">
                <i class="car icon"></i>
                {{occasionsSorting.MileageSorting() == 0 ? "Aucun" :
                occasionsSorting.MileageSorting() == 1 ? "Croissant" : "Décroissant"}}
            </button>
        </div>

        <div class="right item" *ngIf="!deviceInfo.IsMobile()">
            <button class="ui padding-left-20 padding-right-20 button margin-left-20 margin-right-20"
                    (click)="refresh()">Actualiser les occasions
            </button>
        </div>
    </div>

    <button *ngIf="deviceInfo.IsMobile()" class="ui padding-left-20 padding-right-20 button margin-bottom-20"
            (click)="refresh()">Actualiser les occasions</button>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/occasions/presentation/adminOccasionFilter/adminOccasionFilter.html